import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Shield, User, CheckCircle } from 'lucide-react';

const trustPoints = [
  {
    icon: Shield,
    title: "Team signals are anonymized",
    description: "Minimum 3 people required before any team-level insights are shown",
    color: "text-blue-400"
  },
  {
    icon: User,
    title: "Individual content stays private",
    description: "Reflections are private by default — managers only see what's explicitly shared",
    color: "text-green-400"
  },
  {
    icon: CheckCircle,
    title: "Users control visibility",
    description: "Team members choose what evidence appears in their performance summaries",
    color: "text-purple-400"
  }
];

const TeamsTrust = () => {
  return (
    <section 
      id="trust"
      className="py-24 bg-gradient-to-b from-slate-900 to-slate-950"
      data-testid="teams-trust"
    >
      <div className="max-w-5xl mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Built on trust, not surveillance
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            This only works if your team trusts it. That's why privacy is the foundation, not an afterthought.
          </p>
        </div>

        {/* Trust points */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {trustPoints.map((point, index) => (
            <Card 
              key={index}
              className="bg-slate-900/50 border-slate-800 text-center"
              data-testid={`trust-point-${index}`}
            >
              <CardContent className="p-8">
                <div className={`w-14 h-14 rounded-full bg-slate-800 flex items-center justify-center mx-auto mb-5`}>
                  <point.icon className={`w-7 h-7 ${point.color}`} />
                </div>
                <h3 className="text-white font-semibold text-lg mb-2">
                  {point.title}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed">
                  {point.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Bottom tagline */}
        <div className="text-center">
          <p className="text-lg text-slate-300 italic max-w-2xl mx-auto px-6 py-4 border-l-2 border-blue-500/50 bg-slate-900/30 text-left">
            "This isn't employee monitoring. It's a system where your team gets value first — 
            and you get insight as a by-product."
          </p>
        </div>
      </div>
    </section>
  );
};

export default TeamsTrust;
